/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Step Two View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './stepTwoView';

export const mapStateToPropsStepTwo = mapStateToProps;
export const mapDispatchToPropsStepTwo = mapDispatchToProps;

export default connect(mapStateToPropsStepTwo, mapDispatchToPropsStepTwo)(View);
